import { render, staticRenderFns } from "./scroll_scrim.vue.js?vue&type=template&id=58d0ba09!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./scroll_scrim.vue?vue&type=template&id=58d0ba09"
import script from "./scroll_scrim.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./scroll_scrim.vue?vue&type=script&lang=js"
export * from "./scroll_scrim.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./scroll_scrim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58d0ba09')) {
      api.createRecord('58d0ba09', component.options)
    } else {
      api.reload('58d0ba09', component.options)
    }
    module.hot.accept("./scroll_scrim.vue.js?vue&type=template&id=58d0ba09!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./scroll_scrim.vue?vue&type=template&id=58d0ba09", function () {
      api.rerender('58d0ba09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue_shared/components/scroll_scrim/scroll_scrim.vue"
export default component.exports